.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin-top: var(--space-5);
  padding: var(--space-4) var(--space-5);
  background: var(--surface);
  border: var(--border-width) solid var(--border);
  border-radius: var(--radius-lg);
}

.top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.text {
  font-size: var(--text-md);
  color: var(--text-2);
}

.sizeRow {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.select {
  min-height: 2.25rem;
  padding: 0 var(--space-3);
  font-family: var(--font-body);
  font-size: var(--text-md);
  background: var(--surface);
  color: var(--text);
  border: var(--border-width-strong) solid var(--border);
  border-radius: var(--radius-sm);
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pageButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--tap-min);
  height: var(--tap-min);
  padding: 0;
  background: var(--surface-2);
  color: var(--text);
  border: 0;
  border-radius: var(--radius-pill);
  cursor: pointer;
}

.pageButton:disabled {
  opacity: var(--disabled-opacity);
  cursor: not-allowed;
}

.pageLabel {
  font-family: var(--font-heading);
  font-size: var(--text-md);
  font-weight: var(--weight-bold);
}
